import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ProjectJobServiceCreateResponseJson,
  ProjectStakingJson,
} from '@vmspdb/definitions';
import { selectAllClientsMapped } from '../clients';
import { selectAllEmployeesMapped } from '../users';
import * as fromProjectDetails from './project-details.reducer';

export const selectProjectDetailState =
  createFeatureSelector<fromProjectDetails.State>(
    fromProjectDetails.projectDetailsFeatureKey,
  );

export const selectProjectDetailsProject = createSelector(
  selectProjectDetailState,
  (state) => state.project,
);

export const selectProjectDetailsPermits = createSelector(
  selectProjectDetailState,
  (state) => state.permits,
);

export const selectProjectDetailsJobs = createSelector(
  selectProjectDetailState,
  (state): ProjectJobServiceCreateResponseJson[] => state.jobs,
);

export const selectProjectDetailsJobsMapped = createSelector(
  selectProjectDetailState,
  (state) => {
    const map = new Map<string, ProjectJobServiceCreateResponseJson>();
    state.jobs.forEach((job) => {
      if (job.uuid) {
        map.set(job.uuid, job);
      }
    });
    return map;
  },
);

export const selectProjectDetailsSurveys = createSelector(
  selectProjectDetailState,
  selectAllClientsMapped,
  (state, clients) =>
    state.surveys.map((survey) => ({
      ...survey,
      client: clients.get(survey.clientUuid || ''),
    })),
);

export const selectProjectDetailsStakings = createSelector(
  selectProjectDetailState,
  (state): ProjectStakingJson[] => state.project?.surveyTasks?.stakings ?? [],
);

export const selectProjectDetailsClients = createSelector(
  selectProjectDetailsProject,
  selectAllClientsMapped,
  (project, clients) =>
    (project?.clients ?? []).map((client) =>
      clients.get(client as unknown as string),
    ),
);

export const selectProjectDetailsEmployees = createSelector(
  selectProjectDetailsProject,
  selectAllEmployeesMapped,
  (project, employees) =>
    (project?.managers ?? []).map((employee) =>
      employees.get(employee as unknown as string),
    ),
);
